import { useState } from 'react';
import { Modal, Select, Tag } from 'antd';
import { useUpdateDocument } from 'api/documents/use-update-document';
import type { TDocumentType } from 'api/swagger';
import { DocumentType } from 'types/document';
import type { IDocumentTypeButtonProps } from './types';
import { getTagColor } from './utils';

export const DocumentTypeButton: React.FC<IDocumentTypeButtonProps> = (props) => {
  const { type, documentId } = props;
  const color = getTagColor(type);

  const { mutateAsync: updateDocument, isLoading } = useUpdateDocument(documentId);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedType, setSelectedType] = useState<TDocumentType>(type);

  const showModal = () => {
    if (isLoading) return;
    setIsModalVisible(true);
  };

  const closeModal = () => setIsModalVisible(false);

  const handleOk = async () => {
    if (selectedType !== type) {
      await updateDocument({ type: selectedType });
    }
    closeModal();
  };

  const handleChange = (value: TDocumentType) => {
    setSelectedType(value);
  };

  const options = Object.entries(DocumentType).map(([value, label]) => ({ label, value }));

  return (
    <>
      <Tag color={color} style={{ cursor: isLoading ? 'not-allowed' : 'pointer' }} onClick={showModal}>
        {isLoading ? '...' : DocumentType[type]}
      </Tag>
      <Modal
        title='Edit Document Type'
        open={isModalVisible}
        confirmLoading={isLoading}
        onOk={handleOk}
        onCancel={closeModal}>
        <Select value={selectedType} style={{ width: '100%' }} options={options} onChange={handleChange} />
      </Modal>
    </>
  );
};
